import React from 'react';
import { useGatedAccess } from '@carvana/core-auth';
import { LoanCard as Card } from '../_common/card/Card';
import LoanPaidOff from '../_common/loan-paid-off/LoanPaidOff';
import MessageTile from '../_common/message-tile/MessageTile';
import { DateMasks, LoanStatusType, NextPaymentType } from '../../constants';
import { formatCurrency, formatDate } from '../../services/UtilitiesService';
import { isCarvanaNativeApp } from '@carvana/core-native-messaging';

import {
  LoanSummaryWrapper,
  ContentWrapper,
  PaidOffContentWrapper,
  Content,
  Button,
  MessageTileWrapper,
  Caption,
} from './LoanSummaryCard.styles';
import BankIcon from '../../assets/BankIcon';

export const ActiveLoanCard = ({ environment, feedData, handleRedirect }: any) => {
  const gate = useGatedAccess();
  const {
    title,
    callToAction: { title: buttonText },
    caption,
    content: {
      loanSummary: { amountDue, dueDate, loanPaymentStatus, nextPaymentDate, nextPaymentType },
    },
  } = feedData;

  const gatedClickHandler = () => {
    const isNativeApp = isCarvanaNativeApp();
    if (isNativeApp) {
      handleRedirect();
    } else {
      gate('MyCars:LoanManagement', handleRedirect);
    }
  };

  const header = {
    title,
    nextPaymentType,
    paymentType: nextPaymentType === NextPaymentType.ONE_TIME_PAYMENT ? 'Payment' : 'Autopay',
    nextPaymentDate,
  };

  const isOverdue = loanPaymentStatus === 'overdue';
  const alert = isOverdue
    ? {
        text: 'Payment Overdue',
        type: 'warning',
      }
    : undefined;

  // Due Amount and Due Date messages
  let messageTiles: any = [];

  // Show Due Amount and Due Date messages
  if (![LoanStatusType.PAID_OFF, LoanStatusType.NO_LOAN].some((status: string) => status === loanPaymentStatus)) {
    let dueDateValue = dueDate ? formatDate(dueDate, DateMasks.FullMonthDay) : '';

    if (isOverdue) {
      dueDateValue = 'Due Now';
    }

    messageTiles = [
      {
        imageType: 'bank',
        info: amountDue || amountDue === 0 ? formatCurrency(amountDue) : '',
        subTitle: 'Amount Due',
      },
      {
        imageType: 'calendar',
        info: dueDateValue,
        subTitle: 'Due Date',
      },
    ];
  }

  return (
    <LoanSummaryWrapper>
      <Card alert={alert} header={header} headerIcon={<BankIcon />}>
        <ContentWrapper>
          <Content>
            <MessageTileWrapper>
              {messageTiles.map((message: any) => (
                <MessageTile environment={environment} key={message.imageType} message={message} />
              ))}
            </MessageTileWrapper>
            {caption && <Caption data-testid="loan-card-caption-text">{caption}</Caption>}
          </Content>
          <Button data-testid="loan-card-cta-button" size="small" onClick={gatedClickHandler}>
            {buttonText}
          </Button>
        </ContentWrapper>
      </Card>
    </LoanSummaryWrapper>
  );
};

export const PaidOffLoanCard = ({ feedData, handleRedirect }: any) => {
  const {
    title,
    callToAction: { title: buttonText },
  } = feedData;

  const header = {
    title,
  };

  return (
    <LoanSummaryWrapper>
      <Card header={header} headerIcon={<BankIcon />}>
        <PaidOffContentWrapper>
          <Content>
            <LoanPaidOff />
          </Content>
          <Button data-testid="loan-card-cta-button" size="small" onClick={handleRedirect}>
            {buttonText}
          </Button>
        </PaidOffContentWrapper>
      </Card>
    </LoanSummaryWrapper>
  );
};
